
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.06 10.14C20.62 10.6 21.44 10.56 21.95 10.05C22.54 9.45999 22.5 8.47999 21.85 7.94999C18.26 5.00998 13.65 3.91999 9.30004 4.68999L11.89 7.27999C14.78 7.24999 17.69 8.19999 20.06 10.14ZM17.79 11.97C17.01 11.4 16.16 10.97 15.27 10.67L18.22 13.62C18.46 13.04 18.32 12.35 17.79 11.97ZM13.95 16.23C12.73 15.6 11.27 15.6 10.04 16.23C9.45004 16.54 9.34004 17.35 9.81004 17.82L11.28 19.29C11.67 19.68 12.3 19.68 12.69 19.29L14.16 17.82C14.65 17.35 14.55 16.54 13.95 16.23ZM19.68 17.9L4.12004 2.33999C3.73004 1.94999 3.10004 1.94999 2.71004 2.33999C2.32004 2.72999 2.32004 3.35999 2.71004 3.74999L5.05004 6.09999C4.04004 6.59999 3.06004 7.20998 2.16004 7.94999C1.51004 8.47999 1.47004 9.45999 2.06004 10.05C2.57004 10.56 3.38004 10.61 3.93004 10.15C4.93004 9.32999 6.03004 8.68999 7.18004 8.21999L9.41004 10.45C8.28004 10.75 7.20004 11.25 6.22004 11.96C5.53004 12.46 5.49004 13.47 6.09004 14.07L6.10004 14.08C6.59004 14.57 7.36004 14.62 7.93004 14.21C9.12004 13.37 10.51 12.95 11.9 12.92L18.27 19.29C18.66 19.68 19.29 19.68 19.68 19.29C20.07 18.92 20.07 18.29 19.68 17.9Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wifi-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWifiOff

    ```js
    <b-new-b-icon-wifi-off />
    ```
</docs>


